<template>
  <div class="flex flex-column" style="overflow: hidden;">
    <grid-table-wrapper
      :columns="columns"
      class="flex-auto border-right border-bottom all-index"
      style="width: 50px;"
    >
      <grid-header-content
        :columns="columns"
        @click-cell="handleClickHeaderCell"
      >
        <i class="el-icon-d-caret" style="transform: rotate(-45deg);" />
      </grid-header-content>
    </grid-table-wrapper>
    <grid-table-wrapper
      :columns="columns"
      ref="controller"
      class="flex-fill border-right border-bottom border-no-top row-index"
      style="width: 50px; overflow: hidden;"
    >
      <grid-body-content
        :columns="columns"
        :rows="indexRows"
        :line-height-method="() => '30px'"
        :class-method="supplyBodyClass"
        @click-cell="handleClickBodyCell"
      >
        <template v-slot="{ cell }">
          <div class="row-index-cell">
            {{ cell.text }}
          </div>
          <div class="row-resizable"></div>
        </template>
      </grid-body-content>
    </grid-table-wrapper>
  </div>
</template>
<script>
import GridTableWrapper from "@/components/grid/TableWrapper";
import GridHeaderContent from "@/components/grid/HeaderContent";
import GridBodyContent from "@/components/grid/BodyContent";
import { Icon } from "element-ui";

export default {
  name: "grid-row-index",
  components: {
    GridBodyContent,
    GridHeaderContent,
    GridTableWrapper,
    [Icon.name]: Icon,
  },
  props: {
    rows: {
      type: Array,
    },
    selectedPart: Function,
    selectedMethod: Function,
  },
  data() {
    const columns = [{ property: 0, index: 0, width: "50px" }];
    return {
      columns,
    };
  },
  computed: {
    indexRows() {
      return this.rows.map((it, idx) => {
        const index = idx + 1;
        return {
          ...it,
          cells: [{ text: `${index}` }],
        };
      });
    },
  },
  methods: {
    scrollTo({ top }) {
      const { controller } = this.$refs;
      if (controller && controller.$el.scrollTo) {
        const { scrollTop, scrollLeft } = controller;
        if (scrollTop !== top) {
          controller.$el.scrollTo(scrollLeft, top);
        }
      }
    },
    isSelectedPart(index) {
      const { selectedPart } = this;
      if (selectedPart) {
        return selectedPart({ row: { index } });
      }
      return false;
    },
    supplyBodyClass({ row }) {
      const { selected, index } = row;
      // const selectedPart = top && bottom && top <= index && bottom >= index;
      const selectedPart = this.isSelectedPart(index);
      const obj = {
        "selected-all": selected,
        selected: selectedPart && !selected,
      };
      return ["row-index", obj];
    },
    handleClickHeaderCell(params) {
      if (this.$listeners["click-header-cell"]) {
        console.log(params);
        this.$emit("click-header-cell", params);
      }
    },
    handleClickBodyCell(params, event) {
      console.log("触发了行索引点击");
      if (this.$listeners["click-body-cell"]) {
        const { ctrlKey, shiftKey } = event;
        const { row } = params;
        console.log("触发了行索引点击");
        this.$emit("click-body-cell", { row, multi: ctrlKey, range: shiftKey });
      }
    },
  },
};
</script>
